import React from 'react';

import styled from 'styled-components';

import Dropdown from 'components/lib/Dropdown';

import ArrowDownSvgIcon from './ArrowDownSvgIcon';

const StyledDropdownButton = styled(Dropdown.Button)`
  display: flex;
  align-items: center;
  height: 40px;
  color: var(--text-primary);

  .ant-btn {
    gap: 0;
    border-radius: 4px;
    width: auto;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

    &:hover {
      color: var(--text-primary) !important;
    }
  }
`;

const ArrowDownSvgIconWrapper = styled.div`
  padding: 0 2px;
`;

type Props = {
  onClick?: () => void;
  style?: React.CSSProperties;
  overlay: React.ReactNode; // the dropdown menu
  children: React.ReactNode; // button label content (e.g. icon + text)
  dataTestId?: string;
};

const DropdownButton: React.FC<Props> = ({ onClick, style, overlay, children, dataTestId }) => (
  <StyledDropdownButton
    overlay={overlay}
    onClick={onClick}
    data-test-id={dataTestId}
    buttonsRender={
      dataTestId
        ? (buttons: React.ReactNode[]) =>
            buttons.map((button: React.ReactNode, index: number) =>
              React.isValidElement(button)
                ? React.cloneElement(button as React.ReactElement<any>, {
                    'data-test-id': `${dataTestId}-${index === 0 ? 'button' : 'dropdown'}`,
                  })
                : button
            )
        : undefined
    }
    icon={
      <ArrowDownSvgIconWrapper>
        <ArrowDownSvgIcon />
      </ArrowDownSvgIconWrapper>
    }
    style={style}
  >
    {children}
  </StyledDropdownButton>
);

export default DropdownButton;
